import React, { useState } from "react";
import styles from "./Nav.module.css";
import dark from "./NavDark.module.css";
import { Button, Drawer, Dropdown, Menu, Row, Space, Typography } from "antd";
import ConnectWallet from "./ConnectWallet";
import { useWeb3React } from "@web3-react/core";
import { BsFillMoonFill, BsFillSunFill } from "react-icons/bs";
import { Link } from "react-router-dom/dist";
import { sendItem } from "../../util/DropDownList";
const Navbar = ({ theme, setTheme }) => {
  const { library, chainId, account, activate, deactivate, active } =
    useWeb3React();
  const [hamB, setHamB] = useState(false);
  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }
  const hamburgerHandler = () => {
    setHamB(!hamB);
  };
  const itemss = [
    getItem(
      <Link onClick={() => setHamB(false)} to="/">
        <span>HOME</span>
      </Link>,
      "5"
    ),
    getItem(
      <Link onClick={() => setHamB(false)} to="/migration">
        <span>MIGRATION</span>
      </Link>,
      "6"
    ),
    getItem(<p>COLLECTIONS</p>, "sub1", null, [
      getItem(
        <a onClick={() => setHamB(false)} target="_blank"  href="https://opensea.io/collection/dos-punks ">
          DOSPUNKS
        </a>,
        "41231"
      ),
      getItem(
        <a onClick={() => setHamB(false)} target="_blank"  href="https://objkt.com/profile/dos-punks/created">
         DOSPUNKS (Tez)
        </a>,
        "1231"
      ),
      getItem(
        <a onClick={() => setHamB(false)} target="_blank"  href="https://opensea.io/collection/dos-trash-birds">
          DOS TRASHBIRDS
        </a>,
        "124214"
      ),
      getItem(
        <a onClick={() => setHamB(false)} target="_blank"  href="https://opensea.io/collection/dosamigos-official">
          DOSAMIGOS
        </a>,
        "123213"
      ),
    ]),
  ];
  return (
    <nav className={theme ? styles.row : dark.row}>
      <Drawer
        placement={"right"}
        closable={true}
        style={{ width: "100%" }}
        onClose={() => setHamB(false)}
        open={hamB}
        key={"right"}
      >
        <Row className={styles.mobileside}>
          <Menu
            style={{
              width: "100%",
            }}
            defaultSelectedKeys={["1"]}
            defaultOpenKeys={["sub1"]}
            mode="inline"
            items={itemss}
          />
          {false ? (
            <Button
              onClick={() => {
                deactivate();
                localStorage.removeItem("provider");
              }}
              danger
            >
              Logout
            </Button>
          ) : (
            <ConnectWallet />
          )}
        </Row>
      </Drawer>
      <Row>
        <Link to={"/"}>
          {" "}
          <h1 className={styles.title}>DOSPUNKS</h1>{" "}
        </Link>
      </Row>
      <Row>
        <Row style={{ alignItems: "center", marginRight: "1rem", gap: "2rem" }}>
          <Row className={styles.linksRow} style={{ gap: "1rem" }}>
            <Link to={"/"}>
              <span style={{ color: theme ? "#111" : "#f0f0f0" }}> HOME </span>
            </Link>
            <Link to={"/migration"}>
              <span style={{ color: theme ? "#111" : "#f0f0f0" }}>
                MIGRATION
              </span>
            </Link>
            <Dropdown
              trigger={["click"]}
              menu={{
                items: sendItem(theme),
                style: { backgroundColor: theme ? "white" : "#222" },
              }}
            >
              <span
                onClick={(e) => e.preventDefault()}
                style={{ color: theme ? "#111" : "#f0f0f0", cursor:"pointer" }}
              >
                COLLECTIONS
              </span>
              {/* <DownOutlined className={styles.dropDown} /> */}
            </Dropdown>
          </Row>
          {theme ? (
            <BsFillMoonFill
              style={{ fontSize: "18px", cursor: "pointer" }}
              onClick={() => {
                localStorage.setItem("theme", false);
                setTheme(false);
              }}
            />
          ) : (
            <BsFillSunFill
              style={{
                fontSize: "18px",
                cursor: "pointer",
                color: "white",
              }}
              onClick={() => {
                localStorage.setItem("theme", true);
                setTheme(true);
              }}
            />
          )}
        </Row>
        {active ? (
          <Button
            className={styles.disBtn}
            onClick={() => {
              deactivate();
              localStorage.removeItem("provider");
            }}
          >
            Logout
          </Button>
        ) : (
          <Row className={styles.connect}>
            {" "}
            <ConnectWallet theme={theme} setTheme={setTheme} />{" "}
          </Row>
        )}
        <div
          onClick={hamburgerHandler}
          className={`hamburger ${hamB && "open"} flex center`}
          role="button"
          aria-label="Toggle menu"
        >
          <div></div>
        </div>
      </Row>
    </nav>
  );
};

export default Navbar;
